<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">Configurações do cliente</div>
                <div class="client-name">
                  Cliente: {{ this.boobleModalData?.name }}
                </div>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body-content">
            <form [formGroup]="configForm">
              <div>
                <p class="title-form mg-top-8">Configuração de spread</p>

                <div class="row">
                  <mat-radio-group
                    formControlName="isDefaultSpread"
                    class="radios-btns"
                    (change)="onSpreadChange($event)"
                  >
                    <mat-radio-button [value]="true">
                      <span class="label-radio">Spread padrão</span>
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                      <span class="label-radio">Spread personalizado</span>
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <div *ngIf="configForm.get('isDefaultSpread').value == false">
                  <div class="row mt-4">
                    <div class="col-md-8">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Spread personalizado</mat-label>
                        <input
                          matInput
                          type="text"
                          class=""
                          formControlName="spread"
                          currencyMask
                          [options]="{
                            prefix: '',
                            thousands: '.',
                            decimal: ',',
                            suffix: ' %'
                          }"
                          required
                        />
                        <mat-error class="text-danger">
                          Spread personalizado obrigatório</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <p class="title-form mg-top-8">Configuração de tarifa</p>

                <div class="row">
                  <mat-radio-group
                    formControlName="isDefaultTariff"
                    class="radios-btns"
                    (change)="onTariffChange($event)"
                  >
                    <mat-radio-button [value]="true"
                      ><span class="label-radio"
                        >Tarifa padrão</span
                      ></mat-radio-button
                    >
                    <mat-radio-button [value]="false"
                      ><span class="label-radio"
                        >Tarifa personalizada</span
                      ></mat-radio-button
                    >
                  </mat-radio-group>
                </div>
                <div *ngIf="configForm.get('isDefaultTariff').value == false">
                  <div class="row mt-4">
                    <div class="col-md-8">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Tarifa personalizada</mat-label>
                        <input
                          matInput
                          type="text"
                          class=""
                          formControlName="tariff"
                          currencyMask
                          [options]="{
                            prefix: 'R$ ',
                            thousands: '.',
                            decimal: ','
                          }"
                          required
                        />
                        <mat-error class="text-danger">
                          Tarifa personalizada obrigatória</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <p class="title-form mg-top-8">Configuração de Agência</p>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Agência</mat-label>
                    <mat-select formControlName="businessPartnerId" required>
                      <mat-option disabled class="search-option">
                        <ngx-mat-select-search
                          placeholderLabel="Pesquisar agência"
                          noEntriesFoundLabel="Nenhum resultado encontrado"
                          [formControl]="agencyFilterCtrl"
                        >
                        </ngx-mat-select-search>
                      </mat-option>

                      <mat-option
                        *ngFor="let ag of filteredAgencies | async"
                        [value]="ag.id"
                      >
                        Ag {{ ag.agencyNumber }} - {{ ag.companyName }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="
                        configForm
                          .get('businessPartnerId')
                          ?.hasError('required')
                      "
                    >
                      Agência obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div>
                <p class="title-form mg-top-8">Configuração de Perfil</p>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Perfil</mat-label>
                    <mat-select formControlName="profileType" required>
                      <mat-option value="Administrador"
                        >Administrador</mat-option
                      >
                      <mat-option value="Cliente">Cliente</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="
                        configForm.get('profileType')?.hasError('required')
                      "
                    >
                      Perfil obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="modal-footer-new">
          <button
            type="button"
            class="btn-footer btn btn-dark-primary-blue"
            type="button"
            [disabled]="configForm.invalid || loading"
            (click)="sendConfig()"
          >
            Salvar configurações
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
